<template>
  <div
    class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-gray-200 border-0"
  >
  
   <!-- Header with Tabs -->
   <div class="rounded-t bg-white mb-0 px-6 py-6">
      <div class="flex justify-between items-center mb-4">
        <h6 class="text-gray-800 text-xl font-bold">Settings</h6>
        <button
          v-if="activeTab === 'settings'"
          @click="save"
          class="rouanded focus:outline-none outline-none text-gray-100 px-3 py-2 bg-blue-500 hover:shadow-inner hover:bg-blue-700 transition-all duration-300"
          type="button"
        >
          Save settings
        </button>
      </div>

       <!-- Tabs Navigation -->
       <div class="border-b border-gray-200">
        <nav class="-mb-px flex space-x-8">
          <button
            @click="activeTab = 'settings'"
            :class="[
              activeTab === 'settings'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
              'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-lg transition-colors focus:outline-none outline-none'
            ]"
          >
            <i class="fas fa-cog mr-2"></i>
            Settings
          </button>
          
          <button
            v-if="currentUser.type !== 'Seller' && $f.getAccessPermission(currentUser, 'notifications', 'create')"
            @click="activeTab = 'notifications'"
            :class="[
              activeTab === 'notifications'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
              'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-lg transition-colors focus:outline-none outline-none'
            ]"
          >
            <i class="fas fa-bullhorn mr-2"></i>
            Notifications
          </button>
        </nav>
      </div>
    </div>


   <!-- Settings Tab Content -->
    <div
      v-if="activeTab === 'settings' && currentUser.type && currentUser.type !== 'Seller'"
      class="flex-auto px-4 lg:px-10 py-10 pt-0 relative"
    >
      <loading :active.sync="loading" :is-full-page="fullPage"></loading>
      <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">
        Order fees
      </h6>
      <div class="flex flex-wrap">
        <div class="w-full lg:w-4/12 px-4">
          <div class="relative w-full mb-3">
            <label
              class="block uppercase text-gray-700 text-xs font-bold mb-2"
              for="grid-password"
              >Confirmaion fees
              <sup v-if="idWharhouse">({{ idWharhouse.currency }})</sup></label
            >
            <input
              type="number"
              v-model="detail.order.feesConfirmation"
              min="0"
              class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
            />
          </div>
        </div>
        <div class="w-full lg:w-4/12 px-4">
          <div class="relative w-full mb-3">
            <label
              class="block uppercase text-gray-700 text-xs font-bold mb-2"
              for="grid-password"
              >Order fees
              <sup v-if="idWharhouse">({{ idWharhouse.currency }})</sup></label
            >
            <input
              type="number"
              v-model="detail.order.fees"
              min="0"
              class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
            />
          </div>
        </div>
      </div>
      <hr class="mt-6 border-b-1 border-gray-400" />
      <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">
        Shipping fees
      </h6>
      <div class="flex flex-wrap">
        <div class="w-full lg:w-4/12 px-4">
          <div class="relative w-full mb-3">
            <label
              class="block uppercase text-gray-700 text-xs font-bold mb-2"
              for="grid-password"
              >Shipping fees
              <sup v-if="idWharhouse">({{ idWharhouse.currency }})</sup></label
            >
            <input
              type="number"
              v-model="detail.shipping.fees"
              min="0"
              class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
            />
          </div>
        </div>
        <div class="w-full lg:w-4/12 px-4">
          <div class="relative w-full mb-3">
            <label
              class="block uppercase text-gray-700 text-xs font-bold mb-2"
              for="grid-password"
              >Shipping refund
              <sup v-if="idWharhouse">({{ idWharhouse.currency }})</sup></label
            >
            <input
              type="number"
              v-model="detail.shipping.refund"
              min="0"
              class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
            />
          </div>
        </div>
        <div class="w-full lg:w-4/12 px-4">
          <div class="relative w-full mb-3">
            <label
              class="block uppercase text-gray-700 text-xs font-bold mb-2"
              for="grid-password"
              >Shipping change
              <sup v-if="idWharhouse">({{ idWharhouse.currency }})</sup></label
            >
            <input
              type="number"
              v-model="detail.shipping.change"
              min="0"
              class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
            />
          </div>
        </div>
      </div>


            <hr class="mt-6 border-b-1 border-gray-400" />
      <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">
        Upsell & Cross-sell fees
      </h6>
      <div class="flex flex-wrap">
        <div class="w-full lg:w-4/12 px-4">
          <div class="relative w-full mb-3">
            <label
              class="block uppercase text-gray-700 text-xs font-bold mb-2"
              for="grid-password"
              >Upsell fees
              <sup v-if="idWharhouse">({{ idWharhouse.currency }})</sup></label
            >
            <input
              type="number"
              v-model="detail.upsell_fees"
              min="0"
              class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
            />
          </div>
        </div>
        <div class="w-full lg:w-4/12 px-4">
          <div class="relative w-full mb-3">
            <label
              class="block uppercase text-gray-700 text-xs font-bold mb-2"
              for="grid-password"
              >Cross-sell fees
              <sup v-if="idWharhouse">({{ idWharhouse.currency }})</sup></label
            >
            <input
              type="number"
              v-model="detail.crosssell_fees"
              min="0"
              class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
            />
          </div>
        </div>
      </div>

      <!-- Add this section after "Shipping fees" inputs -->
      <hr class="mt-6 border-b-1 border-gray-400" />
      <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">
        Shipping fees by price range
      </h6>

      <div class="w-full px-4 mb-4">
        <button
          @click="addShippingRange"
          class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        >
          <i class="fas fa-plus mr-2"></i>Add Price Range
        </button>
      </div>

      <div class="flex flex-wrap">
        <div
          v-for="(range, index) in detail.shipping.feesRanges"
          :key="index"
          class="w-full lg:w-6/12 xl:w-4/12 px-4 mb-4"
        >
          <div class="bg-white rounded shadow p-4 border border-gray-200">
            <div class="flex justify-between items-center mb-3">
              <span class="font-semibold text-gray-700">Range {{ index + 1 }}</span>
              <button
                @click="removeShippingRange(index)"
                class="text-red-500 hover:text-red-700"
              >
                <i class="fas  fa-trash"></i>
              </button>
            </div>
            
            <div class="mb-3">
              <label class="block uppercase text-gray-600 text-xs font-bold mb-1">
                Min Price <sup v-if="idWharhouse">({{ idWharhouse.currency }})</sup>
              </label>
              <input
                type="number"
                v-model.number="range.minPrice"
                min="0"
                class="px-3 py-2 placeholder-gray-400 text-gray-700 bg-gray-50 rounded text-sm border focus:outline-none focus:border-blue-500 w-full"
              />
            </div>
            
            <div class="mb-3">
              <label class="block uppercase text-gray-600 text-xs font-bold mb-1">
                Max Price <sup v-if="idWharhouse">({{ idWharhouse.currency }})</sup>
                <span class="text-gray-400 normal-case">(0 = no limit)</span>
              </label>
              <input
                type="number"
                v-model.number="range.maxPrice"
                min="0"
                class="px-3 py-2 placeholder-gray-400 text-gray-700 bg-gray-50 rounded text-sm border focus:outline-none focus:border-blue-500 w-full"
              />
            </div>
            
            <div>
              <label class="block uppercase text-gray-600 text-xs font-bold mb-1">
                Shipping Fees <sup v-if="idWharhouse">({{ idWharhouse.currency }})</sup>
              </label>
              <input
                type="number"
                v-model.number="range.fees"
                min="0"
                class="px-3 py-2 placeholder-gray-400 text-gray-700 bg-gray-50 rounded text-sm border focus:outline-none focus:border-blue-500 w-full"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- Preview section -->
      <div v-if="detail.shipping.feesRanges && detail.shipping.feesRanges.length > 0" class="w-full px-4 mt-4">
        <div class="bg-blue-50 border border-blue-200 rounded p-4">
          <h5 class="font-semibold text-blue-800 mb-2">
            <i class="fas fa-info-circle mr-2"></i>Shipping Fees Summary
          </h5>
          <table class="w-full text-sm">
            <thead>
              <tr class="text-left text-blue-700">
                <th class="pb-2">Order Price Range</th>
                <th class="pb-2">Shipping Fees</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(range, index) in sortedRanges" :key="index" class="text-blue-600">
                <td class="py-1">
                  {{ range.minPrice }} {{ idWharhouse ? idWharhouse.currency : '' }} 
                  - 
                  {{ range.maxPrice === 0 ? '∞' : range.maxPrice + ' ' + (idWharhouse ? idWharhouse.currency : '') }}
                </td>
                <td class="py-1 font-semibold">
                  {{ range.fees }} {{ idWharhouse ? idWharhouse.currency : '' }}
                </td>
              </tr>
            </tbody>
          </table>
          <p class="text-xs text-blue-500 mt-2">
            * Default shipping fees ({{ detail.shipping.fees }} {{ idWharhouse ? idWharhouse.currency : '' }}) 
            will be used if order price doesn't match any range
          </p>
        </div>
      </div>

      <hr class="mt-6 border-b-1 border-gray-400" />
      <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">
        Services fees
      </h6>
      <div class="w-full lg:w-4/12 px-4">
        <div class="relative w-full mb-3">
          <label
            class="block uppercase text-gray-700 text-xs font-bold mb-2"
            for="grid-password"
            >Services fees <sup>(%)</sup></label
          >
          <div
            class="flex flex-wrap items-stretch w-full relative bg-white items-center rounded mb-4 shadow"
          >
            <input
              type="number"
              v-model="detail.services_fees"
              class="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border-0 h-10 px-3 py-3 relative self-center font-roboto text-sm placeholder-gray-400 text-gray-700 bg-white outline-none"
              min="0"
            />
            <div class="flex -mr-px">
              <span
                class="flex items-center leading-normal bg-white rounded rounded-l-none border-0 px-3 whitespace-no-wrap text-gray-600"
              >
                %
              </span>
            </div>
          </div>
        </div>
      </div>

      <hr class="mt-6 border-b-1 border-gray-400" />
      <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">
        Subscription fees
      </h6>
      <div class="flex flex-wrap">
        <div class="w-full lg:w-4/12 px-4">
          <div class="relative w-full mb-3">
            <label
              class="block uppercase text-gray-700 text-xs font-bold mb-2"
              for="grid-password"
              >Subscription fees
              <sup v-if="idWharhouse">({{ idWharhouse.currency }})</sup></label
            >
            <input
              type="number"
              v-model="detail.subscription_fees"
              min="0"
              class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
            />
          </div>
        </div>
      </div>



      <hr class="mt-6 border-b-1 border-gray-400" />
      <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">
        Blacklist phone number
      </h6>
      <div class="flex flex-wrap">
        <div class="w-full px-4">
          <div class="relative w-full my-3">
            <div
              class="border border-gray-500 transition-all duration-500 relative rounded p-1"
            >
              <div
                class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
              >
                <p>
                  <label
                    for="cities"
                    class="bg-gray-200 text-gray-700 px-1 uppercase text-xs font-bold"
                    >Add phone
                    <img
                      v-if="idWharhouse && idWharhouse.flag"
                      class="h-4 w-5 inline-block ml-2"
                      :src="idWharhouse.flag"
                  /></label>
                </p>
              </div>
              <div
                id="city"
                class="md:w-full overflow-y-auto h-full flex flex-col items-center p-1"
              >
                <div class="w-full">
                  <div class="flex flex-col items-center relative">
                    <div class="w-full">
                      <div
                        class="mt-2 mb-4 p-1 bg-white flex border border-gray-200 rounded"
                      >
                        <div class="flex flex-auto flex-wrap"></div>
                        <input
                          v-model="phoneInput"
                          @keyup.enter="trigger"
                          placeholder="Enter phone"
                          class="p-1 px-2 appearance-none outline-none w-full text-gray-800"
                        />
                        <div
                          class="text-gray-300 w-8 py-1 pl-2 pr-1 border-l flex items-center border-gray-200"
                        >
                          <button
                            @click="addPhones"
                            ref="sendReply"
                            class="cursor-pointer w-6 h-6 text-blue-500 outline-none focus:outline-none"
                          >
                            <i class="material-icons">add</i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="formData.blacklist_phones.length > 0"
                      class="tag_cities"
                    >
                      <span
                        v-for="(city, index) in formData.blacklist_phones"
                        :key="index"
                        class="tag label label-info"
                      >
                        <span class="text-chip vs-chip--text">{{ city }}</span>
                        <span
                          class="btn-close vs-chip--close"
                          @click="deletePhone(index)"
                          data-role="remove"
                        ></span>
                      </span>
                    </div>
                    <div v-else class="py-2">
                      <span
                        class="w-full flex justify-center text-center border-gray-200 text-base"
                        ><p
                          class="font-semibold flex text-blue-500 whitespace-no-wrap"
                        >
                          <span>No Phone added </span>
                        </p></span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="activeTab === 'settings' && currentUser.type && currentUser.type == 'Seller'"
      class="flex-auto px-4 lg:px-10 py-10 pt-2 relative"
    >
      <loading :active.sync="loading" :is-full-page="fullPage"></loading>

      <div>
        <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">API</h6>
        <div class="flex flex-wrap">
          <div class="w-full md:w-1/2 xl:w-1/2 px-4">
            <div class="ant-col">
              <div class="ant-row">
                <div class="ant-label">
                  <label for="key" class="ant-form" title="identité du client"
                    >API key</label
                  >
                </div>
                <div class="ant-col ant-form-item">
                  <div class="ant-form-item-control has-success">
                    <span class="ant-form-item-children">
                      <span class="ant-input-group-wrapper">
                        <span class="ant-input-group"
                          ><input
                            disabled=""
                            id="key"
                            class="ant-input ant-input-disabled"
                            type="text"
                            :value="currentUser.api ? currentUser.api.key : ''"
                          />
                          <span
                            @click="copyIt('key')"
                            class="ant-input-group-addon"
                          >
                            <svg
                              aria-hidden="true"
                              data-prefix="fal"
                              data-icon="copy"
                              class="svg-inline--fa fa-copy fa-w-14 Icon__StyledIcon-sc-1pfgdmr-0 hahmov"
                              role="img"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 448 512"
                              color="#5c6166"
                            >
                              <path
                                fill="currentColor"
                                d="M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM352 32.491a15.88 15.88 0 0 1 7.431 4.195l51.882 51.883A15.885 15.885 0 0 1 415.508 96H352V32.491zM288 464c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V144c0-8.822 7.178-16 16-16h80v240c0 26.51 21.49 48 48 48h112v48zm128-96c0 8.822-7.178 16-16 16H176c-8.822 0-16-7.178-16-16V48c0-8.822 7.178-16 16-16h144v72c0 13.2 10.8 24 24 24h72v240z"
                              ></path>
                            </svg>
                          </span>
                        </span>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="w-full md:w-1/2 xl:w-1/2 px-4">
            <div class="ant-col">
              <div class="ant-row">
                <div class="ant-label">
                  <label
                    for="secret"
                    class="ant-form"
                    title="identité du client"
                    >API secret key</label
                  >
                </div>
                <div class="ant-col ant-form-item">
                  <div class="ant-form-item-control has-success">
                    <span class="ant-form-item-children">
                      <span class="ant-input-group-wrapper">
                        <span @click="copyIt('secret')" class="ant-input-group"
                          ><input
                            disabled=""
                            id="secret"
                            class="ant-input ant-input-disabled"
                            type="text"
                            :value="
                              currentUser.api ? currentUser.api.secret : ''
                            "
                          />
                          <span class="ant-input-group-addon">
                            <svg
                              aria-hidden="true"
                              data-prefix="fal"
                              data-icon="copy"
                              class="svg-inline--fa fa-copy fa-w-14 Icon__StyledIcon-sc-1pfgdmr-0 hahmov"
                              role="img"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 448 512"
                              color="#5c6166"
                            >
                              <path
                                fill="currentColor"
                                d="M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM352 32.491a15.88 15.88 0 0 1 7.431 4.195l51.882 51.883A15.885 15.885 0 0 1 415.508 96H352V32.491zM288 464c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V144c0-8.822 7.178-16 16-16h80v240c0 26.51 21.49 48 48 48h112v48zm128-96c0 8.822-7.178 16-16 16H176c-8.822 0-16-7.178-16-16V48c0-8.822 7.178-16 16-16h144v72c0 13.2 10.8 24 24 24h72v240z"
                              ></path>
                            </svg>
                          </span>
                        </span>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <hr class="mt-6 border-b-1 border-gray-400" />
        <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">
          Webhooks Management
        </h6>

        <div class="flex flex-wrap mb-4">
          <div class="w-full px-4">
            <button
              @click="showAddWebhook = !showAddWebhook"
              class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mb-4"
            >
              <i class="fas fa-plus mr-2"></i>Add New Webhook
            </button>
          </div>
        </div>

        <div v-if="showAddWebhook" class="bg-gray-100 p-4 rounded mb-4">
          <h4 class="text-lg font-semibold mb-4">{{ editingWebhookIndex !== null ? 'Edit Webhook' : 'Create New Webhook' }}</h4>

          <div class="flex flex-wrap">
            <div class="w-full md:w-1/2 px-4 mb-3">
              <label
                class="block uppercase text-gray-700 text-xs font-bold mb-2"
              >
                Webhook Name *
              </label>
              <input
                v-model="newWebhook.name"
                type="text"
                placeholder="e.g., Order Status Updates"
                class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full"
                maxlength="100"
              />
            </div>

            <div class="w-full md:w-1/2 px-4 mb-3">
              <label
                class="block uppercase text-gray-700 text-xs font-bold mb-2"
              >
                Webhook URL *
              </label>
              <input
                v-model="newWebhook.url"
                type="url"
                placeholder="https://your-site.com/webhook"
                class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full"
                maxlength="500"
              />
            </div>

            <div class="w-full md:w-1/2 px-4 mb-3">
              <label class="block uppercase text-gray-700 text-xs font-bold mb-2">
                Method
              </label>
              <select
                v-model="newWebhook.method"
                class="px-3 py-3 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full"
              >
                <option value="POST">POST (classic webhook)</option>
                <option value="PATCH">PATCH (update status API)</option>
              </select>
              <p v-if="newWebhook.method === 'PATCH'" class="text-xs text-gray-500 mt-1">
                URL supports :code (tracking), :orderId, :reference
              </p>
            </div>

            <div class="w-full px-4 mb-3">
              <label class="block uppercase text-gray-700 text-xs font-bold mb-2">
                Auth Headers
                <span class="text-gray-400 font-normal normal-case ml-1">(optional)</span>
              </label>
              <div v-for="(header, hIdx) in newWebhook.authHeaders" :key="hIdx" class="flex gap-2 mb-2">
                <input
                  v-model="header.key"
                  type="text"
                  placeholder="Header name  e.g. X-API-Key"
                  class="px-3 py-2 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-1/3"
                />
                <input
                  v-model="header.value"
                  type="text"
                  placeholder="Value  e.g. ak_live_..."
                  class="px-3 py-2 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline flex-1"
                />
                <button
                  @click="newWebhook.authHeaders.splice(hIdx, 1)"
                  class="bg-red-100 hover:bg-red-200 text-red-600 px-2 py-1 rounded text-sm"
                >
                  <i class="fas fa-trash"></i>
                </button>
              </div>
              <button
                @click="newWebhook.authHeaders.push({ key: '', value: '' })"
                class="text-blue-600 hover:text-blue-800 text-sm mt-1"
              >
                <i class="fas fa-plus mr-1"></i>Add Header
              </button>
            </div>

            <!-- Status Mapping (optional) -->
            <div class="w-full px-4 mb-3">
              <label class="block uppercase text-gray-700 text-xs font-bold mb-2">
                Status Mapping
                <span class="text-gray-400 font-normal normal-case ml-1">(optional — convert statuses before sending)</span>
              </label>
              <div v-for="(mapping, mIdx) in newWebhook.statusMapping" :key="mIdx" class="flex gap-2 mb-2">
                <input
                  v-model="mapping.from"
                  type="text"
                  placeholder="From (e.g. Confirmed)"
                  class="px-3 py-2 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-1/3"
                />
                <span class="flex items-center text-gray-500 text-sm">&rarr;</span>
                <input
                  v-model="mapping.to"
                  type="text"
                  placeholder="To (e.g. CONFIRMED)"
                  class="px-3 py-2 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline flex-1"
                />
                <button
                  @click="newWebhook.statusMapping.splice(mIdx, 1)"
                  class="bg-red-100 hover:bg-red-200 text-red-600 px-2 py-1 rounded text-sm"
                >
                  <i class="fas fa-trash"></i>
                </button>
              </div>
              <button
                @click="newWebhook.statusMapping.push({ from: '', to: '' })"
                class="text-blue-600 hover:text-blue-800 text-sm mt-1"
              >
                <i class="fas fa-plus mr-1"></i>Add Mapping
              </button>
              <p class="text-xs text-gray-500 mt-1">
                Map your internal statuses to external system codes (e.g. "Confirmed" &rarr; "CONFIRMED", "shipped" &rarr; "DISPATCHED")
              </p>
            </div>

            <div class="w-full px-4 mb-3">
              <label
                class="block uppercase text-gray-700 text-xs font-bold mb-2"
              >
                Select Events *
              </label>

              <div class="space-y-4">
                <div
                  v-for="(events, category) in groupedEvents"
                  :key="category"
                  class="border border-gray-300 rounded p-3"
                >
                  <div class="flex items-center mb-2">
                    <input
                      type="checkbox"
                      :id="`category-${category}`"
                      :checked="isCategorySelected(category)"
                      @change="
                        toggleCategoryEvents(category, $event.target.checked)
                      "
                      class="mr-2"
                    />
                    <label
                      :for="`category-${category}`"
                      class="font-semibold text-gray-800 capitalize cursor-pointer"
                    >
                      {{ category }} Events ({{ events.length }})
                    </label>
                  </div>

                  <div
                    class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 ml-6"
                  >
                    <label
                      v-for="event in events"
                      :key="event.value"
                      class="flex items-center"
                    >
                      <input
                        type="checkbox"
                        :value="event.value"
                        v-model="newWebhook.events"
                        class="mr-2"
                      />
                      <span class="text-sm">{{
                        event.label.replace(
                          `${
                            category.charAt(0).toUpperCase() + category.slice(1)
                          }: `,
                          ""
                        )
                      }}</span>
                    </label>
                  </div>
                </div>
              </div>

              <p class="text-xs text-gray-500 mt-2">
                Select the events that will trigger this webhook. You can select
                individual events or entire categories.
              </p>
            </div>

            <div class="w-full px-4">
              <button
                @click="editingWebhookIndex !== null ? updateWebhook() : addWebhook()"
                :disabled="
                  !newWebhook.name ||
                  !newWebhook.url ||
                  newWebhook.events.length === 0
                "
                class="bg-green-500 hover:bg-green-700 disabled:bg-gray-400 text-white font-bold py-2 px-4 rounded mr-2"
              >
                <i :class="editingWebhookIndex !== null ? 'fas fa-save' : 'fas fa-check'" class="mr-2"></i>
                {{ editingWebhookIndex !== null ? 'Update Webhook' : 'Add Webhook' }}
              </button>
              <button
                @click="cancelAddWebhook"
                class="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
              >
                <i class="fas fa-times mr-2"></i>Cancel
              </button>
            </div>
          </div>
        </div>

        <div
          v-if="formData.webhooks && formData.webhooks.length > 0"
          class="space-y-4"
        >
          <div
            v-for="(webhook, index) in formData.webhooks"
            :key="index"
            class="border border-gray-300 rounded p-4 bg-white shadow-sm"
          >
            <div class="flex justify-between items-start">
              <div class="flex-1">
                <div class="flex items-center mb-2">
                  <h4 class="font-bold text-lg mr-3">{{ webhook.name }}</h4>
                  <span
                    :class="
                      webhook.isActive
                        ? 'bg-green-100 text-green-800'
                        : 'bg-red-100 text-red-800'
                    "
                    class="px-2 py-1 rounded-full text-xs font-semibold"
                  >
                    {{ webhook.isActive ? "Active" : "Inactive" }}
                  </span>
                </div>

                <p class="text-gray-600 mb-2 font-mono text-sm break-all">
                  {{ webhook.url }}
                </p>

                <div class="mb-2">
                  <span class="text-sm font-semibold"
                    >Events ({{ webhook.events.length }}):</span
                  >
                  <div class="flex flex-wrap gap-1 mt-1">
                    <span
                      v-for="event in webhook.events"
                      :key="event"
                      :class="
                        getEventCategory(event) === 'order'
                          ? 'bg-blue-100 text-blue-800'
                          : 'bg-purple-100 text-purple-800'
                      "
                      class="px-2 py-1 rounded text-xs"
                    >
                      {{ formatEventLabel(event) }}
                    </span>
                  </div>
                </div>

                <div class="flex items-center space-x-4 text-sm text-gray-500">
                  <span v-if="webhook.lastTriggered">
                    <i class="fas fa-clock mr-1"></i>
                    Last triggered:
                    {{ new Date(webhook.lastTriggered).toLocaleString() }}
                  </span>
                  <span v-else>
                    <i class="fas fa-clock mr-1"></i>
                    Never triggered
                  </span>

                  <span v-if="webhook.failureCount > 0" class="text-red-600">
                    <i class="fas fa-exclamation-triangle mr-1"></i>
                    Failures: {{ webhook.failureCount }}
                  </span>

                  <span>
                    <i class="fas fa-redo mr-1"></i>
                    Retries: {{ webhook.retryCount || 3 }}
                  </span>

                  <span>
                    <i class="fas fa-stopwatch mr-1"></i>
                    Timeout: {{ webhook.timeout || 5000 }}ms
                  </span>
                </div>

                <div class="mt-2">
                  <span class="text-xs text-gray-500">Secret:</span>
                  <div class="flex items-center">
                    <input
                      type="password"
                      :value="webhook.secret"
                      readonly
                      class="text-xs font-mono bg-gray-100 px-2 py-1 rounded mr-2 w-64"
                    />
                    <button
                      @click="copySecret(index)"
                      class="text-xs bg-gray-200 hover:bg-gray-300 px-2 py-1 rounded"
                    >
                      <i class="material-icons" style="font-size: 12px"
                        >content_copy</i
                      >
                    </button>
                  </div>
                </div>
              </div>

              <div class="flex space-x-2">
                <button
                  @click="viewWebhook(index)"
                  class="bg-gray-500 hover:bg-gray-600 text-white px-3 py-1 rounded text-sm"
                  title="View details"
                >
                  <i class="fas fa-eye mr-1"></i>View
                </button>

                <button
                  @click="editWebhook(index)"
                  class="bg-indigo-500 hover:bg-indigo-600 text-white px-3 py-1 rounded text-sm"
                  title="Edit webhook"
                >
                  <i class="fas fa-edit mr-1"></i>Edit
                </button>

                <button
                  @click="toggleWebhook(index)"
                  :class="
                    webhook.isActive
                      ? 'bg-yellow-500 hover:bg-yellow-600'
                      : 'bg-green-500 hover:bg-green-600'
                  "
                  class="text-white px-3 py-1 rounded text-sm"
                  :title="
                    webhook.isActive ? 'Disable webhook' : 'Enable webhook'
                  "
                >
                  <i
                    :class="webhook.isActive ? 'fas fa-pause' : 'fas fa-play'"
                    class="mr-1"
                  ></i>
                  {{ webhook.isActive ? "Disable" : "Enable" }}
                </button>

                <button
                  @click="testWebhook(index)"
                  class="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded text-sm"
                  title="Send test webhook"
                >
                  <i class="fas fa-flask mr-1"></i>Test
                </button>

                <button
                  @click="deleteWebhook(index)"
                  class="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded text-sm"
                  title="Delete webhook"
                >
                  <i class="fas fa-trash mr-1"></i>Delete
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="text-center py-8 text-gray-500">
          <i class="fas fa-webhook text-4xl mb-4"></i>
          <p class="text-lg">No webhooks configured</p>
          <p class="text-sm">
            Add your first webhook to receive real-time notifications
          </p>
        </div>

        <!-- Modal View Webhook -->
        <div v-if="viewingWebhook" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div class="bg-white rounded-lg shadow-xl w-full max-w-lg mx-4 p-6">
            <div class="flex justify-between items-center mb-4">
              <h4 class="text-lg font-bold">Webhook Details</h4>
              <button @click="viewingWebhook = null" class="text-gray-500 hover:text-gray-700">
                <i class="fas fa-times text-xl"></i>
              </button>
            </div>

            <div class="space-y-3 text-sm">
              <div>
                <span class="font-semibold text-gray-600 uppercase text-xs">Name</span>
                <p class="mt-1">{{ viewingWebhook.name }}</p>
              </div>

              <div>
                <span class="font-semibold text-gray-600 uppercase text-xs">URL</span>
                <p class="mt-1 font-mono break-all bg-gray-50 p-2 rounded">{{ viewingWebhook.url }}</p>
              </div>

              <div>
                <span class="font-semibold text-gray-600 uppercase text-xs">Method</span>
                <p class="mt-1">
                  <span :class="viewingWebhook.method === 'PATCH' ? 'bg-orange-100 text-orange-800' : 'bg-green-100 text-green-800'" class="px-2 py-1 rounded text-xs font-semibold">
                    {{ viewingWebhook.method || 'POST' }}
                  </span>
                </p>
              </div>

              <div v-if="viewingWebhook.authHeaders && viewingWebhook.authHeaders.length > 0">
                <span class="font-semibold text-gray-600 uppercase text-xs">Auth Headers</span>
                <div class="mt-1 space-y-1">
                  <p v-for="(h, hIdx) in viewingWebhook.authHeaders" :key="hIdx" class="font-mono bg-gray-50 p-2 rounded text-sm">
                    <span class="text-blue-700">{{ h.key }}</span>: {{ h.value }}
                  </p>
                </div>
              </div>

              <div v-if="viewingWebhook.statusMapping && viewingWebhook.statusMapping.length > 0">
                <span class="font-semibold text-gray-600 uppercase text-xs">Status Mapping ({{ viewingWebhook.statusMapping.length }})</span>
                <div class="mt-1 space-y-1">
                  <p v-for="(m, mIdx) in viewingWebhook.statusMapping" :key="mIdx" class="font-mono bg-gray-50 p-2 rounded text-sm">
                    <span class="text-gray-700">{{ m.from }}</span>
                    <span class="text-gray-400 mx-2">&rarr;</span>
                    <span class="text-green-700 font-semibold">{{ m.to }}</span>
                  </p>
                </div>
              </div>

              <div>
                <span class="font-semibold text-gray-600 uppercase text-xs">Secret</span>
                <div class="flex items-center mt-1">
                  <input type="password" :value="viewingWebhook.secret" readonly
                    class="font-mono bg-gray-50 p-2 rounded mr-2 flex-1 text-xs border" />
                  <button @click="copySecret(null, viewingWebhook.secret)"
                    class="bg-gray-200 hover:bg-gray-300 px-2 py-2 rounded text-xs">
                    <i class="material-icons" style="font-size:14px">content_copy</i>
                  </button>
                </div>
              </div>

              <div>
                <span class="font-semibold text-gray-600 uppercase text-xs">Events ({{ viewingWebhook.events.length }})</span>
                <div class="flex flex-wrap gap-1 mt-1">
                  <span v-for="event in viewingWebhook.events" :key="event"
                    :class="getEventCategory(event) === 'order' ? 'bg-blue-100 text-blue-800' : 'bg-purple-100 text-purple-800'"
                    class="px-2 py-1 rounded text-xs">
                    {{ formatEventLabel(event) }}
                  </span>
                </div>
              </div>

              <div class="grid grid-cols-2 gap-3">
                <div>
                  <span class="font-semibold text-gray-600 uppercase text-xs">Status</span>
                  <p class="mt-1">
                    <span :class="viewingWebhook.isActive ? 'text-green-600' : 'text-red-600'" class="font-semibold">
                      {{ viewingWebhook.isActive ? 'Active' : 'Inactive' }}
                    </span>
                  </p>
                </div>
                <div>
                  <span class="font-semibold text-gray-600 uppercase text-xs">Retries</span>
                  <p class="mt-1">{{ viewingWebhook.retryCount || 3 }}</p>
                </div>
                <div>
                  <span class="font-semibold text-gray-600 uppercase text-xs">Failures</span>
                  <p class="mt-1" :class="viewingWebhook.failureCount > 0 ? 'text-red-600 font-bold' : ''">
                    {{ viewingWebhook.failureCount || 0 }}
                  </p>
                </div>
                <div>
                  <span class="font-semibold text-gray-600 uppercase text-xs">Last Triggered</span>
                  <p class="mt-1 text-xs">{{ viewingWebhook.lastTriggered ? new Date(viewingWebhook.lastTriggered).toLocaleString() : 'Never' }}</p>
                </div>
              </div>
            </div>

            <div class="mt-5 flex justify-end">
              <button @click="viewingWebhook = null"
                class="bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold px-4 py-2 rounded">
                Close
              </button>
            </div>
          </div>
        </div>

        <div class="mt-8 bg-blue-50 border border-blue-200 rounded p-4">
          <h5 class="font-semibold text-blue-800 mb-2">
            <i class="fas fa-info-circle mr-2"></i>Webhook Information
          </h5>
          <div class="text-sm text-blue-700 space-y-2">
            <p>
              <strong>Headers sent:</strong> Content-Type, X-Webhook-Signature,
              X-Webhook-Event, X-Webhook-Delivery
            </p>
            <p>
              <strong>Signature:</strong> HMAC-SHA256 using your webhook secret
            </p>
            <p>
              <strong>Retry policy:</strong> Failed webhooks are retried up to 3
              times with exponential backoff
            </p>
            <p><strong>Timeout:</strong> Default 5 seconds per request</p>
            <p>
              <strong>Expected response:</strong> 2xx status codes are
              considered successful
            </p>
          </div>
        </div>
      </div>

      <!-- Warehouses Section -->
      <div class="stg-section">
        <div class="stg-section-header">
          <i class="material-icons stg-section-icon">warehouse</i>
          <div>
            <h6 class="stg-section-title">Warehouses</h6>
            <p class="stg-section-desc">Your active country warehouses</p>
          </div>
        </div>
        <div class="stg-warehouses">
          <div
            v-for="(item, index) in currentUser.warehouses"
            :key="index"
            class="stg-warehouse-chip"
          >
            <img class="stg-warehouse-flag" :src="$f.getCountryCode(item.country)" />
            <span class="stg-warehouse-name">{{ item.countryName }}</span>
            <span class="stg-warehouse-code">{{ item.country }}</span>
          </div>
        </div>
      </div>

      <!-- Prefix Order Section -->
      <div class="stg-section">
        <div class="stg-section-header">
          <i class="material-icons stg-section-icon">tag</i>
          <div>
            <h6 class="stg-section-title">Prefix Order</h6>
            <p class="stg-section-desc">Configure order prefix per country</p>
          </div>
        </div>
        <div class="stg-prefix-grid">
          <div
            v-for="item in currentUser.prefixs"
            class="stg-prefix-card"
          >
            <div class="stg-prefix-header">
              <img class="stg-prefix-flag" :src="$f.getCountryCode(item.country)" />
              <span class="stg-prefix-preview">{{ item.name }}_XXXXX</span>
            </div>
            <div class="stg-prefix-fields">
              <div class="stg-prefix-field">
                <label class="stg-prefix-label">Prefix</label>
                <input
                  type="text"
                  placeholder="Prefix ..."
                  v-model="item.name"
                  class="stg-prefix-input"
                />
              </div>
              <div class="stg-prefix-field">
                <label class="stg-prefix-label">Country Name</label>
                <input
                  type="text"
                  placeholder="Country name ..."
                  v-model="item.countryName"
                  class="stg-prefix-input"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Services Section -->
      <div class="stg-section">
        <div class="stg-section-header">
          <i class="material-icons stg-section-icon">miscellaneous_services</i>
          <div>
            <h6 class="stg-section-title">Services & Fees</h6>
            <p class="stg-section-desc">Overview of your current fees</p>
          </div>
        </div>
        <div class="stg-services-grid">
          <!-- Orders -->
          <div class="stg-service-card">
            <div class="stg-service-card-header">
              <div class="stg-service-icon stg-service-icon-blue">
                <i class="material-icons">shopping_cart</i>
              </div>
              <h4 class="stg-service-card-title">Orders</h4>
              <span v-if="idWharhouse" class="stg-service-currency">{{ idWharhouse.currency }}</span>
            </div>
            <div class="stg-service-card-body">
              <div class="stg-service-row">
                <span class="stg-service-label">Confirmation Fees</span>
                <span class="stg-service-value">{{ detail.order.feesConfirmation }}</span>
              </div>
              <div class="stg-service-row">
                <span class="stg-service-label">Order Fees</span>
                <span class="stg-service-value">{{ detail.order.fees }}</span>
              </div>
            </div>
          </div>

          <!-- Shippings -->
          <div class="stg-service-card">
            <div class="stg-service-card-header">
              <div class="stg-service-icon stg-service-icon-green">
                <i class="material-icons">local_shipping</i>
              </div>
              <h4 class="stg-service-card-title">Shippings</h4>
              <span v-if="idWharhouse" class="stg-service-currency">{{ idWharhouse.currency }}</span>
            </div>
            <div class="stg-service-card-body">
              <div class="stg-service-row">
                <span class="stg-service-label">Shipping Fees</span>
                <span class="stg-service-value">{{ detail.shipping.fees }}</span>
              </div>
              <div class="stg-service-row">
                <span class="stg-service-label">Shipping Refund</span>
                <span class="stg-service-value">{{ detail.shipping.refund }}</span>
              </div>
              <div class="stg-service-row">
                <span class="stg-service-label">Shipping Change</span>
                <span class="stg-service-value">{{ detail.shipping.change }}</span>
              </div>
            </div>
          </div>

          <!-- Services -->
          <div class="stg-service-card">
            <div class="stg-service-card-header">
              <div class="stg-service-icon stg-service-icon-purple">
                <i class="material-icons">settings</i>
              </div>
              <h4 class="stg-service-card-title">Services</h4>
              <span class="stg-service-currency">%</span>
            </div>
            <div class="stg-service-card-body">
              <div class="stg-service-row">
                <span class="stg-service-label">Services Fees</span>
                <span class="stg-service-value">{{ detail.services_fees }}%</span>
              </div>
            </div>
          </div>

          <!-- Subscription -->
          <div class="stg-service-card">
            <div class="stg-service-card-header">
              <div class="stg-service-icon stg-service-icon-orange">
                <i class="material-icons">card_membership</i>
              </div>
              <h4 class="stg-service-card-title">Subscription</h4>
              <span v-if="idWharhouse" class="stg-service-currency">{{ idWharhouse.currency }}</span>
            </div>
            <div class="stg-service-card-body">
              <div class="stg-service-row">
                <span class="stg-service-label">Subscription Fees</span>
                <span class="stg-service-value">{{ detail.subscription_fees }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

     <!-- Notifications Tab Content -->
     <div
      v-if="activeTab === 'notifications' && currentUser.type !== 'Seller' && $f.getAccessPermission(currentUser, 'notifications', 'create')"
      class="flex-auto px-4 lg:px-10 py-10 pt-0 relative"
    >
      <NotificationsManagement 
        :currentUser="currentUser" 
        :idWharhouse="idWharhouse"
      />
    </div>


  </div>
</template>

<script>
var phoneUtil = require("google-libphonenumber").PhoneNumberUtil.getInstance();
const PNF = require("google-libphonenumber").PhoneNumberFormat;
import NotificationsManagement from '../settings/notifications.vue';

export default {
  components: {
    NotificationsManagement
  },
  props: {
    currentUser: { type: Object },
    idWharhouse: { type: Object },
  },

  data() {
    return {
      activeTab: 'settings', // 'settings' or 'notifications'
      formData: {
        details: [],
        tva: [],
        blacklist_phones: [],
      },

      detail: {
        shipping: { fees: 0, refund: 0, change: 0,feesRanges: [] },
        order: { feesConfirmation: 0, fees: 0 },
        services_fees: 0,
        subscription_fees: 0,
        upsell_fees: 0,
        crosssell_fees: 0,
        phone: "",
      },

      loading: false,
      fullPage: false,
      tvaInput: "",
      phoneInput: "",

      showAddWebhook: false,
      editingWebhookIndex: null,
      viewingWebhook: null,
      newWebhook: {
        name: "",
        url: "",
        method: "POST",
        authHeaders: [],
        statusMapping: [],
        events: [],
      },

      availableEvents: [
        // Order Events
        { value: "order.pending", label: "Order: Pending", category: "order" },
        { value: "order.waiting", label: "Order: Waiting", category: "order" },
        {
          value: "order.awaiting_deposit",
          label: "Order: En attente de dépot",
          category: "order",
        },
        {
          value: "order.wrong_number",
          label: "Order: Wrong Number",
          category: "order",
        },
        {
          value: "order.confirmed",
          label: "Order: Confirmed",
          category: "order",
        },
        {
          value: "order.cancelled",
          label: "Order: Cancelled",
          category: "order",
        },
        {
          value: "order.unreached",
          label: "Order: Unreached",
          category: "order",
        },
        { value: "order.expired", label: "Order: Expired", category: "order" },
        { value: "order.spam", label: "Order: Spam", category: "order" },
        { value: "order.duplicate", label: "Order: Double", category: "order" },

        // Shipping Events
        {
          value: "shipping.queued",
          label: "Shipping: Queued",
          category: "shipping",
        },
        {
          value: "shipping.prepared",
          label: "Shipping: Prepared",
          category: "shipping",
        },
        {
          value: "shipping.shipped",
          label: "Shipping: Shipped",
          category: "shipping",
        },
        {
          value: "shipping.reprogrammed",
          label: "Shipping: Reprogrammed",
          category: "shipping",
        },
        {
          value: "shipping.received",
          label: "Shipping: Received",
          category: "shipping",
        },
        {
          value: "shipping.paid",
          label: "Shipping: Paid",
          category: "shipping",
        },
        {
          value: "shipping.cancelled",
          label: "Shipping: Cancelled",
          category: "shipping",
        },
        {
          value: "shipping.refunded",
          label: "Shipping: Refunded",
          category: "shipping",
        },
        {
          value: "shipping.processed",
          label: "Shipping: Processed",
          category: "shipping",
        },
      ],
    };
  },

  async mounted() {
    await this.getSettings();
  },

  computed: {
    warhouseSelected() {
      return this.$store.getters["wharhouse/warhouseSelected"]({
        user: _.pick(this.currentUser, ["warehouses"]),
      });
    },
    groupedEvents() {
      const groups = {};
      this.availableEvents.forEach((event) => {
        if (!groups[event.category]) {
          groups[event.category] = [];
        }
        groups[event.category].push(event);
      });
      return groups;
    },
    sortedRanges() {
      if (!this.detail.shipping.feesRanges) return [];
      return [...this.detail.shipping.feesRanges].sort((a, b) => a.minPrice - b.minPrice);
    },
  },

  watch: {
    warhouseSelected: async function (oldVal, newVal) {},

    idWharhouse: async function (oldVal, newVal) {
      this.idWharhouse = oldVal;
      await this.getSettings();
    },
  },

  methods: {
    addShippingRange() {
      if (!this.detail.shipping.feesRanges) {
        this.$set(this.detail.shipping, 'feesRanges', []);
      }
      
      // Get the last range's maxPrice as the new minPrice
      const lastRange = this.detail.shipping.feesRanges[this.detail.shipping.feesRanges.length - 1];
      const newMinPrice = lastRange ? (lastRange.maxPrice || 0) : 0;
      
      this.detail.shipping.feesRanges.push({
        minPrice: newMinPrice,
        maxPrice: 0,
        fees: 0
      });
    },

    removeShippingRange(index) {
      this.detail.shipping.feesRanges.splice(index, 1);
    },
    addWebhook() {
      if (
        !this.newWebhook.name ||
        !this.newWebhook.url ||
        this.newWebhook.events.length === 0
      ) {
        alert("Please fill all required fields", "warning");
        return;
      }

      try {
        new URL(this.newWebhook.url);
      } catch (e) {
        alert("Please enter a valid URL", "warning");
        return;
      }

      if (!this.formData.webhooks) this.formData.webhooks = [];

      const secret = this.generateWebhookSecret();

      const authHeaders = this.newWebhook.authHeaders.filter(h => h.key && h.value);
      const statusMapping = this.newWebhook.statusMapping.filter(m => m.from && m.to);

      this.formData.webhooks.push({
        name: this.newWebhook.name,
        url: this.newWebhook.url,
        method: this.newWebhook.method,
        events: this.newWebhook.events,
        authHeaders,
        statusMapping,
        secret: secret,
        isActive: true,
        retryCount: 3,
        timeout: 5000,
        createdAt: new Date(),
        lastTriggered: null,
        failureCount: 0,
      });

      this.cancelAddWebhook();
      alert("Webhook added — click Save Settings to confirm", "warning");
    },

    cancelAddWebhook() {
      this.showAddWebhook = false;
      this.editingWebhookIndex = null;
      this.newWebhook = { name: "", url: "", method: "POST", authHeaders: [], statusMapping: [], events: [] };
    },

    editWebhook(index) {
      const wh = this.formData.webhooks[index];
      this.editingWebhookIndex = index;
      this.newWebhook = {
        name: wh.name || "",
        url: wh.url || "",
        method: wh.method || "POST",
        authHeaders: (wh.authHeaders || []).map(h => ({ key: h.key || "", value: h.value || "" })),
        statusMapping: (wh.statusMapping || []).map(m => ({ from: m.from || "", to: m.to || "" })),
        events: [...(wh.events || [])],
      };
      this.showAddWebhook = true;
    },

    updateWebhook() {
      if (!this.newWebhook.name || !this.newWebhook.url || this.newWebhook.events.length === 0) {
        alert("Please fill all required fields", "warning");
        return;
      }
      try { new URL(this.newWebhook.url); } catch (e) {
        alert("Please enter a valid URL", "warning");
        return;
      }

      const index = this.editingWebhookIndex;
      const wh = this.formData.webhooks[index];

      wh.name = this.newWebhook.name;
      wh.url = this.newWebhook.url;
      wh.method = this.newWebhook.method;
      wh.events = [...this.newWebhook.events];
      wh.authHeaders = this.newWebhook.authHeaders.filter(h => h.key && h.value);
      wh.statusMapping = this.newWebhook.statusMapping.filter(m => m.from && m.to);

      this.cancelAddWebhook();
      alert("Webhook updated — click Save Settings to confirm", "warning");
    },

    viewWebhook(index) {
      this.viewingWebhook = this.formData.webhooks[index];
    },

    toggleWebhook(index) {
      this.formData.webhooks[index].isActive =
        !this.formData.webhooks[index].isActive;
      alert("Click Save Settings to confirm this change", "warning");
    },

    deleteWebhook(index) {
      this.$confirm("Are you sure you want to delete this webhook?").then(
        async (res) => {
          this.formData.webhooks.splice(index, 1);
          alert("Webhook removed — click Save Settings to confirm", "warning");
        }
      );
    },

    async testWebhook(index) {
      try {
        alert("Sending test webhook...", "info");

        const response = await this.$server.post("webhooks/testWebhook", {
          webhookIndex: index,
          sellerId: this.currentUser._id,
        });

        alert("Webhook test sent successfully", "success");

        this.formData.webhooks[index].lastTriggered = new Date();
      } catch (error) {
        console.error("Webhook test error:", error);
        alert(error.response.data.message || "Webhook test failed", "error");

        this.formData.webhooks[index].failureCount =
          (this.formData.webhooks[index].failureCount || 0) + 1;
      }
    },

    generateWebhookSecret() {
      return Array.from(crypto.getRandomValues(new Uint8Array(32)), (byte) =>
        byte.toString(16).padStart(2, "0")
      ).join("");
    },

    getEventCategory(eventValue) {
      const event = this.availableEvents.find((e) => e.value === eventValue);
      return event ? event.category : "unknown";
    },

    formatEventLabel(eventValue) {
      const event = this.availableEvents.find((e) => e.value === eventValue);
      return event ? event.label : eventValue;
    },

    copySecret(index) {
      const secret = this.formData.webhooks[index].secret;
      navigator.clipboard
        .writeText(secret)
        .then(() => {
          alert("Secret copied to clipboard", "success");
        })
        .catch(() => {
          alert("Failed to copy secret", "error");
        });
    },

    toggleCategoryEvents(category, checked) {
      const categoryEvents = this.availableEvents
        .filter((event) => event.category === category)
        .map((event) => event.value);

      if (checked) {
        categoryEvents.forEach((eventValue) => {
          if (!this.newWebhook.events.includes(eventValue)) {
            this.newWebhook.events.push(eventValue);
          }
        });
      } else {
        this.newWebhook.events = this.newWebhook.events.filter(
          (eventValue) => !categoryEvents.includes(eventValue)
        );
      }
    },

    isCategorySelected(category) {
      const categoryEvents = this.availableEvents
        .filter((event) => event.category === category)
        .map((event) => event.value);

      return categoryEvents.every((eventValue) =>
        this.newWebhook.events.includes(eventValue)
      );
    },

    trigger() {
      this.$refs.sendReply.click();
    },

    copyIt: function (id) {
      document.getElementById(id).removeAttribute("disabled");
      let copyInput = document.querySelector("#" + id);

      copyInput.select();
      document.execCommand("copy");
      document.getElementById(id).setAttribute("disabled", true);
    },

    addPhones(index) {
      if (
        this.phoneInput === "" ||
        this.phoneInput === null ||
        this.phoneInput.value === 0
      ) {
        alert(`Please enter phone in text box below !! `, "warning");
      } else {
        let tel = phoneUtil.parse(
          this.phoneInput.toString(),
          this.idWharhouse.country
        );
        tel = phoneUtil.format(tel, PNF.E164);
        this.formData.blacklist_phones.push(tel);
        this.phoneInput = "";
      }
    },

    deletePhone(index) {
      this.formData.blacklist_phones.splice(index, 1);
    },

    async getUser() {
      const res = await this.$server.me("users");
      if (res.content) this.user = res.content;
      else this.user = [];
    },

    async getwharhouseId() {
      await this.$store
        .dispatch("wharhouse/getwharhouseId", {
          country: this.warhouseSelected,
        })
        .then((res) => {
          this.idWharhouse = res;
        });
    },

    addTva() {
      if (
        this.tvaInput === "" ||
        this.tvaInput === null ||
        this.tvaInput.value === 0
      ) {
        alert(`Please enter tva in text box below !! `, "warning");
      } else if (isNaN(this.tvaInput)) {
        alert(`Please enter a number value`, "warning");
      } else {
        this.formData.tva.push(this.tvaInput);
        this.tvaInput = "";
      }
    },

    deleteTva(index) {
      this.formData.tva.splice(index, 1);
    },

    async save() {
      let data = null;
      if (this.currentUser.type === "Seller") {
        const updateData = {
          _id: this.currentUser._id,
          prefixs: this.currentUser.prefixs.filter(
            (x) => x.name || x.countryName
          ),
        };

        if (this.formData.webhooks && this.formData.webhooks.length > 0) {
          updateData.webhooks = this.formData.webhooks;
        }

        data = await this.$server.update("users", updateData);
      } else {
        const currentSettingW = this.$f.getElementInArray(
          this.formData.details,
          this.idWharhouse
        );

        if (currentSettingW)
          this.$f.changeDataWarhouse(
            this.formData.details,
            this.idWharhouse._id,
            this.detail
          );
        else {
          this.detail.warehouse = this.idWharhouse;
          this.formData.details.push(this.detail);
        }

        data = await this.$server.update("settings", this.formData);
      }

      if (data && data._id) {
        await this.getSettings();
        alert("Setting updated", "success");
      } else alert(data, "warning");
    },

    async getSettings() {
      this.loading = true;

      if (this.currentUser.type === "Seller") {
        this.formData = {
          webhooks: this.currentUser.webhooks || [],
          blacklist_phones: [],
          details: [],
          tva: [],
        };

        if (!this.currentUser.prefixs) this.currentUser.prefixs = [];
        this.currentUser.warehouses.forEach((arg) => {
          var index = this.currentUser.prefixs.findIndex(
            (x) => x.country === arg.country
          );
          if (index === -1 && arg.is_primary)
            this.currentUser.prefixs.push({
              name: "",
              countryName: "",
              country: arg.country,
            });
        });

        // Fetch global settings to display fees for the seller
        const settingsData = await this.$server.get("settings");
        if (settingsData && settingsData.content) {
          const currentSettingW = this.$f.getElementInArray(
            settingsData.content.details,
            this.idWharhouse
          );
          if (currentSettingW) {
            this.detail = currentSettingW;
            if (!this.detail.shipping.feesRanges) {
              this.$set(this.detail.shipping, 'feesRanges', []);
            }
          }
        }
      } else {
        const data = await this.$server.get("settings");
        this.formData = data.content;
        if (!this.formData.blacklist_phones)
          this.formData.blacklist_phones = [];

        const currentSettingW = this.$f.getElementInArray(
          this.formData.details,
          this.idWharhouse
        );

        if (currentSettingW){
          this.detail = currentSettingW;
          // Ensure feesRanges exists
          if (!this.detail.shipping.feesRanges) {
            this.$set(this.detail.shipping, 'feesRanges', []);
          }
        } else
          this.detail = {
            shipping: { fees: 0, refund: 0, change: 0,feesRanges: [] },
            order: { feesConfirmation: 0, fees: 0 },
            services_fees: 0,
          };
      }

      if (!this.formData.webhooks) this.formData.webhooks = [];

      this.loading = false;
    },
  },
};
</script>

<style scoped>
.ant-row input:focus-visible + .ant-input-group-addon {
  outline: 2px solid rgb(72, 156, 248);
}
.ant-row {
  position: relative;
  height: auto;
  padding: 0;
  color: #4d4d4d;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: "tnum";
  margin-bottom: 24px;
  zoom: 1;
  display: block;
  box-sizing: border-box;
  cursor: pointer;
}
.ant-label {
  display: inline-block;
  overflow: hidden;
  line-height: 39.9999px;
  white-space: nowrap;
  text-align: right;
  vertical-align: middle;
}
.ant-col {
  position: relative;
  min-height: 1px;
}
.ant-row label {
  position: relative;
}
.ant-label > label {
  color: rgba(0, 0, 0, 0.85);
}
.ant-form-item-control {
  position: relative;
  line-height: 40px;
  zoom: 1;
}
.ant-form-item-children {
  position: relative;
}
.ant-input-group-wrapper {
  display: inline-block;
  width: 100%;
  text-align: start;
  vertical-align: top;
}
.ant-input-group {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #4d4d4d;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  display: table;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}
.ant-input[disabled] {
  background: rgb(247, 249, 250);
}
.ant-input-group > .ant-input:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ant-input {
  height: 40px;
  float: left;
  width: 100%;
  margin-bottom: 0;
  text-align: inherit;
  touch-action: manipulation;
  -webkit-appearance: none;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  padding: 4px 11px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  transition: all 0.3s;
  font-size: 14px;
  line-height: 1.5;
  border-collapse: separate;
  border-spacing: 0;
}
.ant-input-group-addon:last-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 0;
}
.ant-input-group-addon {
  position: relative;
  padding: 0 11px;
  color: #4d4d4d;
  font-weight: 400;
  font-size: 14px;
  text-align: center;
  background-color: #fafafa;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  transition: all 0.3s;
}
.ant-input-group-addon,
.ant-input-group-wrap {
  width: 1px;
  white-space: nowrap;
  vertical-align: middle;
}
.ant-input-group-addon,
.ant-input-group-wrap,
.ant-input-group > .ant-input {
  display: table-cell;
}
.tag-rail {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
  padding: 0;
  white-space: nowrap;
}
.rail-container {
  overflow: hidden;
  height: 36px;
  padding-top: 6px;
  cursor: pointer;
  scroll-behavior: smooth;
}
.tag {
  background: #e3ebf7;
  border-radius: 8px;
  padding: 3px 8px 4px;
  margin: 5px 4px;
  color: #285192;
  font-weight: 500;
  user-select: none;
  border: 1px solid #e3ebf7;
  transition-duration: 0.25s;
  white-space: nowrap;
  border: 2px dashed #013179;
}
.tag:first-child {
  margin-left: 16px;
}
.tag:last-child {
  margin-right: 16px;
}
.tag:hover {
  background: #dce4f0;
}
.tag:active {
  background: #e3ebf7;
}
.tag-selected {
  background: #3b71ca;
  color: #fff;
  border: 1px solid #3b71ca;
}
.tag-selected:hover {
  background: #3265b9;
  color: #fff;
}
.tag-selected:active {
  background: #3b71ca;
  color: #fff;
}
.btn-left-con,
.btn-right-con {
  position: absolute;
}
.btn-right-con {
  right: 0;
}
.btn-left,
.btn-right {
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  border-radius: 100%;
  cursor: pointer;
  transition-duration: 0.25s;
  box-shadow: 0 0 16px 24px #fff;
  background: #fff;
}
.btn-left {
  margin-left: 2px;
}
.btn-right {
  margin-right: 2px;
}
.btn-left:hover,
.btn-right:hover {
  background: #f2f2f2;
}
.btn-left:active,
.btn-right:active {
  background: #d9d9d9;
}
/* ===== Settings Sections ===== */
.stg-section {
  margin-top: 28px;
  padding: 0 16px;
}
.stg-section-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
}
.stg-section-icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: rgba(66, 133, 244, 0.1);
  color: #4285f4;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.stg-section-title {
  font-size: 15px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.stg-section-desc {
  font-size: 12px;
  color: #9ca3af;
  margin: 2px 0 0;
}

/* Warehouses */
.stg-warehouses {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.stg-warehouse-chip {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  background: #fff;
  border: 1.5px solid #e5e7eb;
  border-radius: 12px;
  transition: all 0.2s ease;
}
.stg-warehouse-chip:hover {
  border-color: #4285f4;
  box-shadow: 0 2px 8px rgba(66, 133, 244, 0.1);
}
.stg-warehouse-flag {
  width: 24px;
  height: 16px;
  border-radius: 2px;
  object-fit: cover;
}
.stg-warehouse-name {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
}
.stg-warehouse-code {
  font-size: 11px;
  font-weight: 700;
  color: #4285f4;
  background: rgba(66, 133, 244, 0.08);
  padding: 2px 8px;
  border-radius: 6px;
  letter-spacing: 0.05em;
}

/* Prefix Order */
.stg-prefix-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 12px;
}
.stg-prefix-card {
  background: #fff;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.2s ease;
}
.stg-prefix-card:hover {
  border-color: #4285f4;
  box-shadow: 0 4px 12px rgba(66, 133, 244, 0.08);
}
.stg-prefix-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #f8fafc;
  border-bottom: 1px solid #f0f0f0;
}
.stg-prefix-flag {
  width: 22px;
  height: 15px;
  border-radius: 2px;
  object-fit: cover;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12);
}
.stg-prefix-preview {
  font-size: 12px;
  font-weight: 700;
  color: #4285f4;
  font-family: monospace;
  letter-spacing: 0.05em;
}
.stg-prefix-fields {
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.stg-prefix-field {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.stg-prefix-label {
  font-size: 10px;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.stg-prefix-input {
  width: 100%;
  padding: 6px 10px;
  font-size: 13px;
  color: #1f2937;
  background: #f9fafb;
  border: 1.5px solid #e5e7eb;
  border-radius: 8px;
  outline: none;
  transition: all 0.2s ease;
}
.stg-prefix-input:focus {
  background: #fff;
  border-color: #4285f4;
  box-shadow: 0 0 0 3px rgba(66, 133, 244, 0.1);
}

/* Services Grid */
.stg-services-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}
@media (max-width: 1024px) {
  .stg-services-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 640px) {
  .stg-services-grid {
    grid-template-columns: 1fr;
  }
}
.stg-service-card {
  background: #fff;
  border: 1.5px solid #e5e7eb;
  border-radius: 14px;
  overflow: hidden;
  transition: all 0.2s ease;
}
.stg-service-card:hover {
  border-color: transparent;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}
.stg-service-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 18px 12px;
}
.stg-service-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.stg-service-icon i {
  font-size: 20px;
  color: #fff;
}
.stg-service-icon-blue { background: linear-gradient(135deg, #4285f4, #5a9cf6); }
.stg-service-icon-green { background: linear-gradient(135deg, #34a853, #4cba6a); }
.stg-service-icon-purple { background: linear-gradient(135deg, #7c3aed, #9f67ff); }
.stg-service-icon-orange { background: linear-gradient(135deg, #f59e0b, #fbbf24); }

.stg-service-card-title {
  font-size: 15px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0;
  flex: 1;
}
.stg-service-currency {
  font-size: 11px;
  font-weight: 600;
  color: #9ca3af;
  background: #f3f4f6;
  padding: 2px 8px;
  border-radius: 6px;
}
.stg-service-card-body {
  padding: 0 18px 16px;
}
.stg-service-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #f3f4f6;
}
.stg-service-row:last-child {
  border-bottom: none;
}
.stg-service-label {
  font-size: 13px;
  color: #6b7280;
}
.stg-service-value {
  font-size: 14px;
  font-weight: 700;
  color: #1a1a2e;
}

.container-2 {
  max-width: 1140px;
  margin: auto;
  padding: 0 15px;
}
.xpt-center {
  text-align: center;
}

.toggle__dot {
  top: -0.25rem;
  left: -0.25rem;
  transition: all 0.3s ease-in-out;
}

input:checked ~ .toggle__dot {
  transform: translateX(100%);
  background-color: #63b3ed;
}
.hori-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.vs-chip--close {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 0;
  margin: 0 4px;
  margin-left: 8px;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.15);
  color: #fff;
  transition: all 0.3s ease;
}
.vs-chip--close:after {
  content: "x";
  padding: 0px 2px;
  margin-bottom: 3px;
  font-size: 15px;
}
.max-height-200 {
  max-height: 200px;
}
.tag_cities {
  max-height: 19vh;
  overflow-y: scroll;
}
.tag_cities::-webkit-scrollbar {
  width: 7px;
}
.tag_cities::-webkit-scrollbar-thumb {
  background-color: #babac0;
  border-radius: 16px;
}
.dtag_cities::-webkit-scrollbar-thumb:hover {
  background-color: #a0a0a5;
  border: 4px solid #f4f4f4;
}
.dropdown_warhouse::-webkit-scrollbar-button {
  display: none;
}

.xpt *,
.xpt *:after,
.xpt *:before {
  -webkit-transition: all 0.25s linear;
  -moz-transition: all 0.25s linear;
  -ms-transition: all 0.25s linear;
  -o-transition: all 0.25s linear;
  transition: all 0.25s linear;
}

.xpt-hex {
  font-family: "Lato", sans-serif;
  position: relative;
  z-index: 0;
  color: #fff;
  display: inline-block;
  margin: 80px 5px 75px 5px;
}
.xpt-hex:after {
  content: "";
  position: absolute;
  -webkit-transform: rotate(60deg);
  -moz-transform: rotate(60deg);
  -ms-transform: rotate(60deg);
  -o-transform: rotate(60deg);
  transform: rotate(60deg);
}
.xpt-hex:before {
  content: "";
  position: absolute;
  -webkit-transform: rotate(-60deg);
  -moz-transform: rotate(-60deg);
  -ms-transform: rotate(-60deg);
  -o-transform: rotate(-60deg);
  transform: rotate(-60deg);
}
.xpt-hex,
.xpt-hex:after,
.xpt-hex:before {
  width: 250px;
  height: 143px;
  background: #fff;
  text-align: justify;
}

.xpt-ihex {
  position: absolute;
  z-index: 1;
  left: 12px;
  right: 12px;
  top: 6px;
  bottom: 6px;
}
.xpt-ihex:after {
  content: "";
  position: absolute;
  -webkit-transform: rotate(60deg);
  -moz-transform: rotate(60deg);
  -ms-transform: rotate(60deg);
  -o-transform: rotate(60deg);
  transform: rotate(60deg);
}
.xpt-ihex:before {
  content: "";
  position: absolute;
  -webkit-transform: rotate(-60deg);
  -moz-transform: rotate(-60deg);
  -ms-transform: rotate(-60deg);
  -o-transform: rotate(-60deg);
  transform: rotate(-60deg);
}
.xpt-ihex,
.xpt-ihex:after,
.xpt-ihex:before {
  background: #3182ce;
}

.xpt-ihex:after,
.xpt-ihex:before {
  width: 100%;
  height: 100%;
}
.xpt-box-inr {
  z-index: 2;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
}
.xpt-box-1 {
  font-weight: 300;
}
.xpt-title {
  font-size: 24px !important;
  font-family: "Lato", sans-serif;
  margin: 0;
  padding: 0;
  font-weight: 300 !important;
  text-transform: uppercase;
  margin-top: 43px !important;
}
.xpt-price-box {
  font-weight: 300 !important;
  display: inline-block;
  position: relative;
}
.xpt-price {
  font-size: 90px;
  line-height: 60px;
}
.xpt-price span {
  position: absolute;
  left: 100%;
  font-size: 40px;
  top: -14px;
}
.xpt-currency {
  position: absolute;
  left: -20px;
  top: -8px;
  font-size: 40px;
}
.xpt-duration {
  position: absolute;
  font-size: 20px;
  bottom: -30px;
  left: 0;
  right: 0;
}
.xpt-box-2 {
  position: absolute;
  left: 0;
  right: 0;
  top: 50px;
  opacity: 0;
  padding: 0 5px;
  margin-top: 16px;
}
.xpt-fleft {
  text-align: left;
}
.xpt-fcenter {
  text-align: center;
}
.xpt-fright {
  text-align: right;
}
.xpt-body,
.xpt-body li {
  list-style: none;
  margin: 0 !important;
  padding: 0;
}
.xpt-body li {
  line-height: 19px;
  font-size: 10px;
  padding: 4px 0;
  position: relative;
}

.xpt-body li span {
  display: inline-block;
  cursor: help;
  border-bottom: dotted 2px #fff;
}
.xpt-body li span:before {
  content: "";
  position: absolute;
  top: -15px;
  width: 12px;
  height: 12px;
  left: 50%;
  margin-left: -6px;
}
.xpt-body li span i {
  margin: 0;
  margin-bottom: 15px;
  position: absolute;
  bottom: 100%;
  display: inline-block;
  padding: 0 5px;
  border-radius: 3px;
  text-align: center;
  background: #3182ce;
  left: 0px;
  right: 0px;
}
.xpt-body li span:before,
.xpt-body li span i {
  width: 0;
  height: 0;
  display: inline-block;
  overflow: hidden;
  border: 0;
}
.xpt-body li span:hover:before,
.xpt-body li span:hover i {
  opacity: 1;
  width: auto;
  height: auto;
  overflow: visible;
}
.xpt-body li span:hover:before {
  top: 0;
  border-width: 6px;
  border-style: solid;
  border-color: #fff transparent transparent transparent;
}
.xpt-body li span:hover i {
  margin-bottom: 0;
  padding: 4px;
  border: 2px solid #fff;
}

.xpt-btn {
  font-size: 13px;
  display: inline-block;
  color: #fff !important;
  padding-top: 25px;
  text-decoration: none;
  box-shadow: none !important;
  text-transform: uppercase;
}

.xpt-body li i,
.xpt-btn i {
  margin-right: 3px;
  font-size: 10px;
  vertical-align: unset;
}

.xpt-hex:hover .xpt-box-1 {
  opacity: 0;
}
.xpt-hex:hover .xpt-box-2 {
  opacity: 1;
  top: 0;
}

.xpt-hex.xpt-cw:hover,
.xpt-hex.xpt-acw:hover .xpt-ihex {
  -webkit-transform: rotate(60deg);
  -moz-transform: rotate(60deg);
  -ms-transform: rotate(60deg);
  -o-transform: rotate(60deg);
  transform: rotate(60deg);
}

.xpt-hex.xpt-cw:hover .xpt-ihex,
.xpt-hex.xpt-acw:hover {
  -webkit-transform: rotate(-60deg);
  -moz-transform: rotate(-60deg);
  -ms-transform: rotate(-60deg);
  -o-transform: rotate(-60deg);
  transform: rotate(-60deg);
}

.xpt-hex.xpt-zoom:hover .xpt-ihex {
  -webkit-transform: scale(1.105, 1.105);
  -moz-transform: scale(1.105, 1.105);
  -ms-transform: scale(1.105, 1.105);
  -o-transform: scale(1.105, 1.105);
  transform: scale(1.105, 1.105);
}

.xpt-hex.xpt-zoom-out .xpt-ihex {
  -webkit-transform: scale(1.105, 1.105);
  -moz-transform: scale(1.105, 1.105);
  -ms-transform: scale(1.105, 1.105);
  -o-transform: scale(1.105, 1.105);
  transform: scale(1.105, 1.105);
}

.xpt-hex.xpt-zoom-out:hover .xpt-ihex {
  -webkit-transform: scale(1, 1);
  -moz-transform: scale(1, 1);
  -ms-transform: scale(1, 1);
  -o-transform: scale(1, 1);
  transform: scale(1, 1);
}

.xpt-hex.xpt-inr-cw:hover .xpt-ihex .xpt-box-inr,
.xpt-hex.xpt-inr-acw:hover .xpt-ihex,
.xpt-hex.xpt-acw.xpt-zoom:hover .xpt-box-inr {
  -webkit-transform: rotate(60deg);
  -moz-transform: rotate(60deg);
  -ms-transform: rotate(60deg);
  -o-transform: rotate(60deg);
  transform: rotate(60deg);
}

.xpt-hex.xpt-inr-cw:hover .xpt-ihex,
.xpt-hex.xpt-inr-acw:hover .xpt-ihex .xpt-box-inr,
.xpt-hex.xpt-cw.xpt-zoom:hover .xpt-box-inr {
  -webkit-transform: rotate(-60deg);
  -moz-transform: rotate(-60deg);
  -ms-transform: rotate(-60deg);
  -o-transform: rotate(-60deg);
  transform: rotate(-60deg);
}

.xpt-hex.xpt-clr-cng:hover,
.xpt-hex.xpt-clr-cng:hover:after,
.xpt-hex.xpt-clr-cng:hover:before {
  background: #3182ce;
}

.xpt-hex.xpt-flip {
  -webkit-perspective: 1000;
  -moz-perspective: 1000;
  -ms-perspective: 1000;
  perspective: 1000;
}
.xpt-hex.xpt-flip .xpt-box-2,
.xpt-hex.xpt-zoom-in-out .xpt-box-2 {
  top: 0;
}
.xpt-hex.xpt-flip:hover .xpt-ihex,
.xpt-hex.xpt-flip:hover .xpt-box-inr {
  -webkit-transform: rotateY(180deg);
  -moz-transform: rotateY(180deg);
  -ms-transform: rotateY(180deg);
  -o-transform: rotateY(180deg);
  transform: rotateY(180deg);
}

.xpt-hex.xpt-flip.xpt-frl:hover .xpt-ihex,
.xpt-hex.xpt-flip.xpt-frl:hover .xpt-box-inr {
  -webkit-transform: rotateY(-180deg);
  -moz-transform: rotateY(-180deg);
  -ms-transform: rotateY(-180deg);
  -o-transform: rotateY(-180deg);
  transform: rotateY(-180deg);
}

.xpt-hex.xpt-flip.xpt-ftb:hover .xpt-ihex,
.xpt-hex.xpt-flip.xpt-ftb:hover .xpt-box-inr {
  -webkit-transform: rotateX(-180deg);
  -moz-transform: rotateX(-180deg);
  -ms-transform: rotateX(-180deg);
  -o-transform: rotateX(-180deg);
  transform: rotateX(-180deg);
}

.xpt-hex.xpt-flip.xpt-fbt:hover .xpt-ihex,
.xpt-hex.xpt-flip.xpt-fbt:hover .xpt-box-inr {
  -webkit-transform: rotateX(180deg);
  -moz-transform: rotateX(180deg);
  -ms-transform: rotateX(180deg);
  -o-transform: rotateX(180deg);
  transform: rotateX(180deg);
}

.xpt-hex.xpt-zoom-in-out:hover .xpt-ihex {
  -webkit-animation: xptzoom-in-out 0.5s;
  animation: xptzoom-in-out 0.5s;
}

@keyframes xptzoom-in-out {
  0% {
    -webkit-transform: scale(1, 1);
    -moz-transform: scale(1, 1);
    -ms-transform: scale(1, 1);
    -o-transform: scale(1, 1);
    transform: scale(1, 1);
  }
  50% {
    -webkit-transform: scale(0.4, 0.4);
    -moz-transform: scale(0.4, 0.4);
    -ms-transform: scale(0.4, 0.4);
    -o-transform: scale(0.4, 0.4);
    transform: scale(0.4, 0.4);
  }
  100% {
    -webkit-transform: scale(1, 1);
    -moz-transform: scale(1, 1);
    -ms-transform: scale(1, 1);
    -o-transform: scale(1, 1);
    transform: scale(1, 1);
  }
}
</style>
